export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Weight Votes',
        category: 'BGG',
        description: 'Number of community votes received for the game weight.',
        summarise: {
            prefix: 'Community weight'
        },
        unit: 'vote'
    },
    rules: {
        linked: [],
        legacy: ['threshold.weight']
    }
}